import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  title?: ReactNode;
  right?: ReactNode;
  className?: string;
  bodyClassName?: string;
  rightClassName?: string;
}

export default function CommandPanel({
  children,
  title,
  right,
  className = '',
  bodyClassName = '',
  rightClassName = '',
}: Props) {
  return (
    <section className={`ui-command-panel ${className}`}>
      {(title !== undefined || right !== undefined) && (
        <header className="ui-command-panel__header">
          <div className="min-w-0 truncate">{title}</div>
          {right && <div className={`ui-command-panel__actions ${rightClassName}`}>{right}</div>}
        </header>
      )}
      <div className={`ui-command-panel__body ${bodyClassName}`}>{children}</div>
    </section>
  );
}
